import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 6h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 10h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 14h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 18h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Building2";
const Building2 = memo(themed(Icon));
export {
  Building2
};
//# sourceMappingURL=building-2.js.map
